<template>
    <div v-if="anyForwardingAddresses">
        <div class="tab-pane slide-left active">
            <template v-if="!editing._new">
                <div class="row column-separation">

                    <div class="col-md-6"
                         @keyup.esc="editing._default = false">
                        <h3>Adresse de réexpedition par défaut</h3>
                        <forwarding-address :address="defaultForwardingAddress"
                                            :is-active="isActiveForwardingAddress(defaultForwardingAddress)"
                                            :should-edit="canEditDefaultAddress"
                                            :customer="profile"
                                            :contractId="id"
                                            v-if="!editing._default"
                                            @edit="editForwardingAddress(defaultForwardingAddress.id, '_default')">
                        </forwarding-address>

                        <resource-form v-else
                                       :model="form.model"
                                       :schema="form.schema"
                                       :triggers="form.triggers"
                                       @submit="updateForwardingAddress($event, '_default')">
                            <button slot="cancel"
                                    class="btn btn-danger btn-sm"
                                    @click.prevent="editing._default = false">
                                Annuler
                            </button>
                        </resource-form>

                    </div>
                    <div class="col-md-6"
                         v-if="anyFutureDefaultAddress"
                         @keyup.esc="editing.future_default = false">
                        <h3>Adresse de réexpedition par défaut
                            <u>en attente</u>
                        </h3>
                        <forwarding-address :address="futureDefaultForwardingAddress"
                                            :should-edit="canEditFutureDefaultAddress"
                                            :is-active="isActiveForwardingAddress(futureDefaultForwardingAddress)"
                                            :customer="profile"
                                            :contractId="id"
                                            v-if="!editing.future_default"
                                            @edit="editForwardingAddress(futureDefaultForwardingAddress.id, 'future_default')">
                        </forwarding-address>
                        <resource-form v-else
                                       :model="form.model"
                                       :schema="form.schema"
                                       :triggers="form.triggers"
                                       @submit="updateForwardingAddress($event, 'future_default')">
                            <button slot="cancel"
                                    class="btn btn-danger btn-sm"
                                    @click.prevent="editing.future_default = false">
                                Annuler
                            </button>
                        </resource-form>

                    </div>
                </div>
            </template>
            <div class="row">
                <div class="col-md-12">
                    <h3>Adresse de réexpedition ponctuelle</h3>
                    <button class="btn btn-complete"
                            v-if="!editing._new"
                            @click="prepareNewForwardAddressesForm">
                        Ajouter
                    </button>
                    <template v-else>
                        <div class="m-b-10">
                            <button class="btn btn-danger"
                                    @click="editing._new = false">
                                Annuler
                            </button>
                        </div>
                        <resource-form :schema="newForm.schema"
                                       :model="newForm.model"
                                       :triggers="newForm.triggers"
                                       @submit="addPunctualForwardingAddress">
                        </resource-form>
                    </template>

                </div>
                <div class="col-md-12"
                     v-if="anyPunctualAdresses && !editing._new">
                    <forwarding-address v-for="address in punctualForwardingAddress"
                                        :key="'forwarding-address-'+address.id"
                                        :address="address"
                                        :is-active="isActiveForwardingAddress(address)"
                                        :customer="profile"
                                        :contractId="id"
                                        :should-delete="true"
                                        @delete="removeForwardingAddress(address.id)"
                                        :should-edit="false">
                    </forwarding-address>
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script type="text/babel">
    import DefaultForwardingAddress from './ForwardingAddresses/DefaultForwardingAddress'
    import OneTimeForwardingAddress from './ForwardingAddresses/OneTimeForwardingAddress'
    import ForwardingAddress from './ForwardingAddresses/ForwardingAddress'
    import contractsMixin from 'mixins/contracts'
    import ResourceForm from "components/Forms/ResourceForm"

    import { mapState, mapActions, mapGetters } from 'vuex'
    export default {

        name: 'ForwardingAddresses',

        components: {
            DefaultForwardingAddress,
            OneTimeForwardingAddress,
            ForwardingAddress,
            ResourceForm,
        },


        data () {
            return {
                editing: {
                    active: false,
                    _default: false,
                    future_default: false,
                    punctual: false,
                    _new: false,
                },
                form: {},
                newForm: {},
            }
        },

        created () {
        },

        computed: {
            ...mapState('contract', [
                'id',
                'defaultForwardingAddress',
                'futureDefaultForwardingAddress',
                'activeForwardingAddress',
                'punctualForwardingAddress',
                'contractMailOption',
            ]),

            ...mapState('customer', [
                'profile'
            ]),

            ...mapGetters('contract', [
                'anyPunctualAdresses',
                'anyForwardingAddresses',
                'anyFutureDefaultAddress',
                'canEditDefaultAddress',
                'canEditFutureDefaultAddress',
            ]),

            // getTimestamp: function (flag) {
            //   const model = this.model,
            //   modelField =  flag ? model.mail_forward_start_date : model.mail_forward_end_date
            //   return moment(modelField).format('YYYY-MM-DD [at] hh:mm')
            // },
        },

        methods: {
            ...mapActions('contract', [
                'fetchForwardingAddresses',
            ]),


            addPunctualForwardingAddress ({ data: model }) {
                model.validation_override = __REQUESTS_VALIDATION_OVERRIDE__
                return this.axios.post(
                    `contracts/${this.id}/options/${this.contractMailOption.id}/addresses`,
                    model
                ).then(() => {
                    this.fetchForwardingAddresses()
                        .then(() => this.editing._new = false)

                })
            },

            removeForwardingAddress (addressId) {
                return this.axios.delete(
                    `contracts/${this.id}/options/${this.contractMailOption.id}/addresses/${addressId}`
                ).then(this.fetchForwardingAddresses)
            },

            editForwardingAddress (addressId, type) {
                return this.axios.get(
                    `contracts/${this.id}/options/${this.contractMailOption.id}/addresses/${addressId}/edit`
                ).then(response => {
                    this.form = _.assign({}, response.data.form)
                    this.editing[type] = true
                })
            },

            updateForwardingAddress ($event, type) {
                // debugger
                const model = $event.data,
                    addressId = model.address.id

                model.validation_override = __REQUESTS_VALIDATION_OVERRIDE__
                return this.axios.put(
                    `contracts/${this.id}/options/${this.contractMailOption.id}/addresses/${addressId}`,
                    model
                ).then(response => {
                    this.fetchForwardingAddresses()
                    this.editing[type] = false
                })
            },

            prepareNewForwardAddressesForm () {
                return this.axios.get(
                    `contracts/${this.id}/options/${this.contractMailOption.id}/addresses/create`
                ).then(response => {
                    this.newForm = _.assign({}, response.data.form)
                    this.newForm.model.address.moral_person = false
                    this.editing._new = true
                })
            },

            isActiveForwardingAddress (address) {
                return address.id === this.activeForwardingAddress.id
            },


        },
    }
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/ForwardingAddresses.vue